/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import { Consumer as ItemManagersConsumer } from '@jira/platform__services-item-managers/src/index.tsx';
import { ImperativeAPI as ImperativeAPIWrapped } from './controllers/index.tsx';

const ImperativeAPI = (): React.JSX.Element => (
	<ItemManagersConsumer>
		{({ getManager }) => <ImperativeAPIWrapped getItemManager={getManager} />}
	</ItemManagersConsumer>
);

export { ImperativeAPI };
